import React, { useEffect, useState } from "react";
import makeStyles from "@material-ui/styles/makeStyles";
import api from "../../../common/api";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import useTheme from "@material-ui/styles/useTheme";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';

const useStyles = makeStyles(theme => ({
  formControl: {
    minWidth: 220,
  },
  textField: {
    margin: theme.spacing(1),
    marginTop: theme.spacing(0)
  },
  signInButton: {
    margin: theme.spacing(2, 0)
  },
  datePicker: {
    marginTop: theme.spacing(2),
    margin: theme.spacing(1),
    minWidth: 160
  }
}));

const BatchesListBox = ({
  showError,
  match,
  setValid,
  getChosenBatch,
  setLoading
}) => {
  const theme = useTheme();

  const farmID = match.params["farmID"];
  const [batches, setBatches] = useState([]);
  const [batchIndex, setBatchIndex] = useState("");
  const [includeOnlyInActiveBatch, setIncludeOnlyInActiveBatch] = useState(false);
  const [originalBatches, setOriginalBatches] = useState([]);
  const [activeBatches, setActiveBatches] = useState([]);



  const isDesktop = useMediaQuery(theme.breakpoints.up("md"), {
    defaultMatches: true
  });

  const classes = useStyles({ isDesktop });

  const loadBatchList = function() {
    showError("");
    setLoading(true);
    const response = api.get(`farm/${farmID}/batch`);
    //const response = api.get(`farm/20/batch`);
    response
      .then(res => {
        setOriginalBatches([
          ...res
        ])
        console.debug("event ",  res)
        if (includeOnlyInActiveBatch) {
          setBatches(res)
        } else {
          let tempBatches = []
          res.forEach(element => {
            console.debug(element)
            if (element.isActive) {
              console.debug("isActive")
              tempBatches = ([
                ...tempBatches,
                {
                  ...element
                }
              ]);
            }
          });
          setBatches(tempBatches)
          setActiveBatches(tempBatches)

        }
      })
      .catch(err => {
        if (err.message) {
          if (err.message === "Bad Request" || err.message === "No data found")
            showError(err.message);
        } else {
          showError("Unknown Error");
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(loadBatchList, [showError]);
  useEffect(() => {
    if (batchIndex !== "") {
      setValid(true);
    } else {
      setValid(false);
    }
  }, [batchIndex, setValid]);

  const onChangeOfBatches = function(index) {
    setBatchIndex(index);
    getChosenBatch(batches[index]);
  };

  const handleIncludeInActiveBatch = function (event) {
    console.debug("event ", event.target.checked, originalBatches)
    setIncludeOnlyInActiveBatch(event.target.checked);
    if (event.target.checked) {
      let tempInactiveBatches = []
      originalBatches.forEach(element => {
        console.debug(element)
        if (!element.isActive) {
          console.debug("isInactive")
          tempInactiveBatches = ([
            ...tempInactiveBatches,
            {
              ...element
            }
          ]);
        }
      });
      setBatches(tempInactiveBatches)
    } else {
      setBatches(activeBatches)    
    }
  };

  return (
    // One compact row: Batch select and the inactive switch (wraps on small screens)
    <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 12 }}>
      <FormControl variant="outlined" size="small" className={classes.formControl}>
        <InputLabel id="batchName-select-label">Batch</InputLabel>
        <Select
          id="batchName-select"
          labelId="batchName-select-label"
          label="Batch"
          value={batchIndex !== undefined ? batchIndex : ""}
          onChange={event => onChangeOfBatches(event.target.value)}
          name="batchIndex"
        >
          {batches.map((batch, index) => (
            <MenuItem key={batch.id} value={index}>
              {batch.name+ " (" + batch.shedName +")"}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
        <FormControlLabel
          control={
            <Switch
              checked={includeOnlyInActiveBatch}
              onChange={handleIncludeInActiveBatch}
              color="primary"
              inputProps={{ 'aria-label': 'primary checkbox' }}
            />
          }
          label="Show Inactive Batches only"
        />
    </div>
  );
};

export default BatchesListBox;
